import { forwardRef, useState, useCallback } from 'react'
import { OTPInput, SlotProps } from 'input-otp'
import type { OTPInputProps } from 'input-otp'
import classNames from 'classnames'

import styles from './index.less'
import { escape } from 'lodash'

interface IProps {
  length: number
  value?: string
  status?: string
  autoFocus?: boolean
  disabled?: boolean
  onInput?: (v: string) => void
  onChange?: (v: string) => void
}
const InputOTP = forwardRef<any, IProps>((props, ref) => {
  const { length, status, onInput, onChange, ...overrideProps } = props

  const [value, setValue] = useState('');

  const handleInputChange = (v: string) => {
    if (value?.length === length && v?.length === length) {
      return;
    }

    setValue(v)
    onInput?.(v)
  }

  return (
    <OTPInput
      ref={ref}
      maxLength={length}
      containerClassName={styles.inputContainer}
      value={value}
      onChange={handleInputChange}
      onComplete={onChange}
      render={({ slots }) => {
        return (
          <div className={classNames([styles.slots, styles[`${status}`]])}>
            {slots.map((slot, idx) => (
              <Slot key={idx} {...slot} />
            ))}
          </div>
        )
      }}
      {...(overrideProps || {})}
    />
  )
})

function Slot(props: SlotProps) {
  return (
    <div className={classNames([styles.slot, { [styles.active]: props.isActive }])}>
      {props.char !== null && <div>{props.char}</div>}
      {props.hasFakeCaret && <FakeCaret />}
    </div>
  )
}

// You can emulate a fake textbox caret!
function FakeCaret() {
  return (
    <div className={styles['fake-caret-container']}>
      <div className={styles['fake-caret']} />
    </div>
  )
}
export default InputOTP
